import { Component, inject, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pages-wrapper',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './pages-wrapper.component.html',
  styleUrl: './pages-wrapper.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class PagesWrapperComponent {
  #activatedRoute = inject(ActivatedRoute);
  #translateService = inject(TranslateService);

  ngOnInit() {
    this.#translateService.setDefaultLang(
      this.#activatedRoute.snapshot.params['lang'] || 'en'
    );
  }
}
